function promptUserForPassword(data) {
  return {
    type: 'RE_AUTHENTICATION_NEED_UPDATE',
    data,
  };
}

export {promptUserForPassword};
